const DateRollConstants = {
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
};

const DateRollStatus = {
  ACTIVE: 0,
  DELETED: 1,
  INACTIVE: 2,
};

const DateRollLogStatus = {
  CREATED: 0,
  UPDATED: 1,
  REMOVED: 2,
  INACTIVE: 3,
};

const DateRollActionStatus = {
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
};

module.exports = {
  DateRollConstants,
  DateRollStatus,
  DateRollLogStatus,
  DateRollActionStatus,
};
